// Package Imports
import axios from "axios";
import { toJS } from "mobx";

// Project Imports
import * as APITypes from "constants/API";
import generateToggleHighRiskDataStructure from "./generateToggleHighRiskDataStructure";
import updateProductwiseRiskData from "../updateProductwiseRiskData";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import { API_DELAY_TIME } from "constants/Constants";

const toggleHighRiskTabFunction = async (reqObj) => {
  generateToggleHighRiskDataStructure(reqObj);
  reqObj.risk_type = "high";

  let familyProductIdList = [];
  let productListData = toJS(OptimizationStore.product_list_data);
  productListData.forEach((outerObj) =>
    outerObj.data.forEach((innerObj) => {
      if (Array.isArray(innerObj.BI))
        familyProductIdList.push(innerObj.family_product_id);
    })
  );

  let requestList = [];
  familyProductIdList.forEach((item) => {
    requestList.push({ ...reqObj, family_product_id: item });
  });

  const promises = [];
  
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  
  async function makeRequests() {
    for (const item of requestList) {
      promises.push(axios.post(APITypes.SELECT_NEW_HIGH_RISK, item));
      await delay(API_DELAY_TIME);
    }
  
    const results = await Promise.all(promises);
    
    results.forEach((result) => {
      if (result.status.toLowerCase() === "success" && result.data.high_risk_data !== "") {
        let responseData = {
          data: result.data.high_risk_data,
          status: "success",
        };
        updateProductwiseRiskData(responseData);
      }
    });
  }
  
  makeRequests()
    .then(() => {
      console.log("All requests completed");
    })
    .catch((error) => {
      console.error("Error making requests: ", error);
    });
  
};

export default toggleHighRiskTabFunction;
